document.querySelectorAll(".btn-view-360").forEach(function(btn) {
  btn.addEventListener("click", function(e) {
    e.preventDefault();
    document.querySelector(".view-popup").classList.add("open");
  });
});
document.querySelectorAll(".view-overlay").forEach(function(btn) {
  btn.addEventListener("click", function(e) {
    e.preventDefault();
    document.querySelector(".view-popup").classList.remove("open");
  });
});
document.querySelectorAll(".close-360-popup").forEach(function(btn) {
  btn.addEventListener("click", function(e) {
    e.preventDefault();
    document.querySelector(".view-popup").classList.remove("open");
  });
});

function animateScroll(target, duration) {
  var targetElement = document.querySelector(target);
  var targetOffset = targetElement.offsetTop - 110;
  var startOffset = window.pageYOffset;
  var startTime = null;

  function scrollStep(timestamp) {
    if (!startTime) startTime = timestamp;
    var progress = timestamp - startTime;
    var scrollDistance = targetOffset - startOffset;
    var currentScroll = easeInOutCubic(progress, startOffset, scrollDistance, duration);

    window.scrollTo(0, currentScroll);

    if (progress < duration) {
      requestAnimationFrame(scrollStep);
    }
  }

  function easeInOutCubic(t, b, c, d) {
    t /= d / 2;
    if (t < 1) return c / 2 * t * t * t + b;
    t -= 2;
    return c / 2 * (t * t * t + 2) + b;
  }

  requestAnimationFrame(scrollStep);
}

document.querySelectorAll(".menu-sidebar a").forEach(function(element) {
  element.addEventListener('click', function(e) {
    var target = this.getAttribute('href');
  });
});

(function ($) {
  $(document).ready(function () {

    var needShow = window.location.hash.substring(1);

    if(needShow){
      $('.shopify-section [data-target]').each(function () {
        if($(this).attr("data-target") != needShow){
          $(this).closest('.shopify-section').removeClass("active").hide();
        }else{
          $(this).closest('.shopify-section').addClass("active").show();
        }
      })
    }

    $(".menu-sidebar a").on("click", function (e) {
      e.preventDefault();
      window.location.href = $(this).attr('href');
      var target = $(this).attr('href').replace('#', '');
      if(target){
        $('.shopify-section [data-target]').closest(".shopify-section").removeClass("active").hide();
        $('.shopify-section [data-target="' + target + '"]').closest(".shopify-section").addClass("active").show();
      }
    })
  })
})(jQuery)

        document.querySelectorAll('.go-top a[href^="#"]').forEach(anchor => {
            anchor.addEventListener('click', function(e) {
                e.preventDefault();

                const targetId = this.getAttribute('href').substring(1);
                const targetElement = document.getElementById(targetId);

                if (targetElement) {
                    window.scrollTo({
                        top: targetElement.offsetTop,
                        behavior: 'smooth'
                    });
                }
            });
        });

$(function(){ 

  $(window).scroll(function () {
      var scroll = $(window).scrollTop();
      if (scroll > 150){
        $("body").addClass("on");
      } else {
        $("body").removeClass("on");
      }
  });
});

(function() {
  function getBeltProperties() {
    const activeModel = document.querySelector('.belt-model-btn.active');
    if (!activeModel || activeModel.dataset.model === '__none__') return null;
    const modelValue = activeModel.dataset.model;
    const activeSwatch = document.querySelector('.belt-color-swatch.active[data-model="' + modelValue + '"]');

    const colorValue = activeSwatch ? activeSwatch.dataset.label : '';
    return { model: modelValue, color: colorValue };
  }

  function injectBelt(form) {
    const belt = getBeltProperties();
    if (!belt) { console.log('No belt selected'); return; }
    form.querySelectorAll('input[name^="properties[ベルト"]').forEach(el => el.remove());
    ['ベルトモデル', 'ベルトカラー'].forEach(function(key) {
      const input = document.createElement('input');
      input.type = 'hidden';
      input.name = 'properties[' + key + ']';
      input.value = key === 'ベルトモデル' ? belt.model : (belt.color || '');
      form.appendChild(input);
    });
    console.log('Belt injected:', belt);
  }

  document.addEventListener('click', function(e) {
    const btn = e.target.closest('.cowlendar-add-to-cart, button[name="add"], [data-add-to-cart]');
    if (!btn) return;
    const form = btn.closest('form');
    if (!form) return;
    injectBelt(form);
  }, true);

  document.addEventListener('submit', function(e) {
    const form = e.target;
    if (!form.action || !form.action.includes('/cart/add')) return;
    injectBelt(form);
  }, true);

  console.log('Belt listener ready');
})();
 
(function() {
  function getBeltProperties() {
    const activeModel = document.querySelector('.belt-model-btn.active');
    if (!activeModel || activeModel.dataset.model === '__none__') return null;
    const modelValue = activeModel.dataset.model;
    const activeSwatch = document.querySelector(`.belt-color-swatch.active[data-model="${modelValue}"]`);
    const colorValue = activeSwatch ? activeSwatch.dataset.label : '';
    return { model: modelValue, color: colorValue };
  }

  function injectBelt(form) {
    const belt = getBeltProperties();
    if (!belt) { console.log('No belt selected'); return; }
    form.querySelectorAll('input[name^="properties[belt"]').forEach(el => el.remove());
    ['belt-model', 'belt-color'].forEach(function(key) {
      const input = document.createElement('input');
      input.type = 'hidden';
      input.name = 'properties[' + key + ']';
      input.value = key === 'belt-model' ? belt.model : (belt.color || '');
      form.appendChild(input);
    });
    console.log('Belt injected:', belt);
  }

  document.addEventListener('click', function(e) {
    const btn = e.target.closest('.cowlendar-add-to-cart, button[name="add"], [data-add-to-cart]');
    if (!btn) return;
    const form = btn.closest('form');
    if (!form) return;
    injectBelt(form);
  }, true);

  document.addEventListener('submit', function(e) {
    const form = e.target;
    if (!form.action || !form.action.includes('/cart/add')) return;
    injectBelt(form);
  }, true);

  console.log('Belt listener ready');
})();
